import { Module, Mutation } from 'vuex-module-decorators'
import BaseStore from '@/store/BaseStore'
import { BibliographyClass } from '@/types'
import {
  BibliographyDetailAuthority,
  BibliographyTagData,
  defaultSystemCode,
  SystemCode
} from '@/api'

export interface ModalBibliographyTagDataEditOkItem {
  bibliographyId: number
  title: string
}

export interface ModalBibliographyTagDataEditStoreInterface {
  isEdit?: boolean
  isCopy?: boolean
  bibliographyClass: BibliographyClass
  searchType: SystemCode
  editBibliographyId?: number
  bibliographyRealId?: number
  bibliographySetId?: number
  serial?: number
  details?: BibliographyTagData[]
  authorities?: BibliographyDetailAuthority[]
  revision?: number
  onOk?: (item: ModalBibliographyTagDataEditOkItem) => void
  onCancel?: () => void
}

@Module({
  name: 'ModalBibliographyTagDataEditStore',
  namespaced: true,
  stateFactory: true
})
export default class ModalBibliographyTagDataEditStore extends BaseStore {
  _beforeOpen: boolean = false

  _isOpen: boolean = false

  _isEdit: boolean = false

  _isCopy: boolean = false

  _bibliographyClass: BibliographyClass = BibliographyClass.Real

  _searchType: SystemCode = defaultSystemCode()

  _editBibliographyId?: number = undefined

  _bibliographyRealId?: number = undefined

  _bibliographySetId?: number = undefined

  _serial?: number = undefined

  _details: BibliographyTagData[] = []

  _authorities: BibliographyDetailAuthority[] = []

  _revision?: number = undefined

  _onOkCallback?: (item: ModalBibliographyTagDataEditOkItem) => void

  _onCancelCallback?: () => void

  get beforeOpen(): boolean {
    return this._beforeOpen
  }

  get isOpen(): boolean {
    return this._isOpen
  }

  get isEdit(): boolean {
    return this._isEdit
  }

  get isCopy(): boolean {
    return this._isCopy
  }

  get bibliographyClass(): BibliographyClass {
    return this._bibliographyClass
  }

  get searchType() {
    return this._searchType
  }

  get editBibliographyId(): number | undefined {
    return this._editBibliographyId
  }

  get bibliographyRealId(): number | undefined {
    return this._bibliographyRealId
  }

  get bibliographySetId(): number | undefined {
    return this._bibliographySetId
  }

  get serial(): number | undefined {
    return this._serial
  }

  get details(): BibliographyTagData[] {
    return this._details
  }

  get authorities(): BibliographyDetailAuthority[] {
    return this._authorities
  }

  get revision(): number | undefined {
    return this._revision
  }

  @Mutation
  public open(params: ModalBibliographyTagDataEditStoreInterface) {
    this._beforeOpen = true
    this._isEdit = params.isEdit !== undefined ? params.isEdit : false
    this._isCopy = params.isCopy !== undefined ? params.isCopy : false
    this._bibliographyClass = params.bibliographyClass
    this._searchType = params.searchType
    this._editBibliographyId = params.editBibliographyId
    this._bibliographyRealId = params.bibliographyRealId
    this._bibliographySetId = params.bibliographySetId
    this._serial = params.serial
    this._details = params.details !== undefined ? params.details : []
    this._authorities =
      params.authorities !== undefined ? params.authorities : []
    this._revision = params.revision
    this._onOkCallback = params.onOk
    this._onCancelCallback = params.onCancel
  }

  @Mutation
  public close() {
    this._isOpen = false
    this._isEdit = false
    this._isCopy = false
    this._bibliographyClass = BibliographyClass.Real
    this._searchType = defaultSystemCode()
    this._editBibliographyId = undefined
    this._bibliographyRealId = undefined
    this._bibliographySetId = undefined
    this._serial = undefined
    this._details = []
    this._authorities = []
    this._revision = undefined
    this._onOkCallback = undefined
    this._onCancelCallback = undefined
  }

  @Mutation
  public ready() {
    this._beforeOpen = false
    this._isOpen = true
  }

  @Mutation
  public ok(item: ModalBibliographyTagDataEditOkItem) {
    console.log('@@@ok', item)
    if (this._onOkCallback) this._onOkCallback(item)
  }

  @Mutation
  public cancel() {
    if (this._onCancelCallback) this._onCancelCallback()
  }
}
